/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Voice_Manager_Pin_Success_ToastInputs */



/**
* | output |
* | --- |
* | "{name} pinned successfully" |
*
* @param {Voice_Manager_Pin_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_pin_success_toast = /** @type {((inputs: Voice_Manager_Pin_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Pin_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} epingle avec succes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} erfolgreich angeheftet`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} bloccato con successo`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.name} успешно закреплен`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} fijado exitosamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.name} 已成功固定`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} が正常にピン留めされました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} सफलतापूर्वक पिन किया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.name} fixado com sucesso`)
	return /** @type {LocalizedString} */ (`${i?.name} pinned successfully`)
});